import { Container, Row, Col, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Btn } from 'AbstractElements';
import CategoriesBox from './CategoriesBox';
import { useDispatch, useSelector } from 'react-redux';
import CategoryFilter from '../Common/CategoryFilter';
import { resetState } from 'Features/Learning/Categories/addCategoriesSlice';

const CategoriesContain = () => {
  const dispatch = useDispatch();
  const handleAdd = () => {
    dispatch(resetState());
  };
  const cards = useSelector(state => state.Categories.data.data)

  return (
    <Container fluid={true}>
      <Col md="12" className="project-list">
        {cards && (
          <Card>
            <Row>
              <Col>
                Keterangan: <br />
                - Kategori induk digunakan untuk Tryout/Quiz. <br />
                - Kategori anak digunakan untuk Soal. <br />
              </Col>
              <Col>
                <Link to={`${process.env.PUBLIC_URL}/learning/category-add`} onClick={handleAdd}>
                  <Btn attrBtn={{ color: 'primary' }}>
                    <i className="fa fa-plus-circle fa-lg"></i> Tambah Kategori Baru
                  </Btn>
                </Link>
              </Col>
            </Row>
          </Card>
        )}
      </Col>
      <Row className='learning-block'>
        <Col xl="9 xl-80">
          <Row>
            <CategoriesBox />
          </Row>
        </Col>
        {cards && (
          <CategoryFilter />
        )}
      </Row>
    </Container>
  );
};
export default CategoriesContain;